var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary"},[_c('div',{staticClass:"summary__text"},[_c('p',{staticClass:"summary__text__title"},[_vm._v("Total Payable Amount")]),_vm._v(" "),_c('p',{staticClass:"summary__text__value"},[_vm._v("₹"+_vm._s(_vm.payableAmount))])]),_vm._v(" "),_c('img',{staticClass:"summary__image",attrs:{"src":require("../../../static/images/check-green.svg"),"alt":"green-checkmark"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-520e29a1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/EplNewPaymentSummaryCard/component.html
// module id = null
// module chunks = 